import React from 'react'
import PropTypes from 'prop-types'
import {useIntl} from 'react-intl'
import ImageTextTile from '@consteed/overrides/page-designer/assets/image-text-tile'
import Link from '@consteed/overrides/components/link'
import {generalUrlBuilder} from '@consteed/overrides/utils/url'
import {hrefToLinkObject} from '@consteed/frontend/utils/richTextConfigurations'
import useTracking from '@consteed/frontend/hooks/use-tracking'
import {APP_STORE_LINK_ANDROID, APP_STORE_LINK_IOS} from '@consteed/overrides/constants'

/**
 * LinkTile component
 *
 * @param {object} props
 * @param {string} - props.link - sfcc href for link
 * @param {string} - props.text - Text on Image.
 * @param {image} - props.image - Image.
 * @param {string} - props.alt - The image alt text shown by the component.
 * @param {boolean} - props.withHoverTransition - If image should be zoomed on hover
 * @param {function} - props.onClick - Action to execute if LinkTile is clicked
 * @param {string} - props.variant - display variant for ImageTextTile
 * @returns {React.ReactElement} - LinkTile component.
 */
export const LinkTile = ({
    link,
    image,
    alt,
    text,
    backgroundTheme,
    withHoverTransition,
    onClick,
    variant
}) => {
    const {locale} = useIntl()
    const linkObject = hrefToLinkObject(link)
    const {eventTracking} = useTracking()

    let appLinkTracking
    if (!onClick && linkObject?.type === 'external') {
        if (linkObject.url === APP_STORE_LINK_ANDROID) {
            appLinkTracking = () => {
                try {
                    eventTracking('appstore', {
                        OS: 'Android',
                        source: 'linktile'
                    })
                } catch (error) {
                    // catch tracking error
                }
            }
        }
        if (linkObject.url === APP_STORE_LINK_IOS) {
            appLinkTracking = () => {
                try {
                    eventTracking('appstore', {
                        OS: 'Android',
                        source: 'linktile'
                    })
                } catch (error) {
                    // catch tracking error
                }
            }
        }
    }
    return (
        <Link to={generalUrlBuilder(linkObject, locale)} onClick={onClick || appLinkTracking}>
            <ImageTextTile
                image={image}
                alt={alt}
                text={text}
                backgroundTheme={backgroundTheme}
                withHoverTransition={withHoverTransition}
                variant={variant}
            />
        </Link>
    )
}

LinkTile.propTypes = {
    link: PropTypes.string,
    text: PropTypes.string,
    image: PropTypes.shape({
        _type: PropTypes.string,
        focalPoint: PropTypes.shape({
            _type: PropTypes.string,
            x: PropTypes.number,
            y: PropTypes.number
        }),
        metaData: PropTypes.shape({
            _type: PropTypes.string,
            height: PropTypes.number,
            width: PropTypes.number
        }),
        url: PropTypes.string,
        src: PropTypes.string || PropTypes.object
    }).isRequired,
    alt: PropTypes.string,
    backgroundTheme: PropTypes.string,
    withHoverTransition: PropTypes.bool,
    onClick: PropTypes.func,
    variant: PropTypes.string
}

export default LinkTile
